import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const socialMediaApi = createApi({
  reducerPath: "socialMediaApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["SocialPosts", "SocialAnalytics"],
  endpoints: (builder) => ({
    getPosts: builder.query({
      query: (params = {}) => ({
        url: "/social-media-posts",
        params,
      }),
      transformResponse: (response) => response.data || { posts: [], total: 0 },
      providesTags: ["SocialPosts"],
    }),

    getPostById: builder.query({
      query: (id) => `/social-media-posts/${id}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, id) => [{ type: "SocialPosts", id }],
    }),

    createPost: builder.mutation({
      query: (data) => ({
        url: "/social-media-posts",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["SocialPosts", "SocialAnalytics"],
    }),

    updatePost: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/social-media-posts/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["SocialPosts", "SocialAnalytics"],
    }),

    deletePost: builder.mutation({
      query: (id) => ({
        url: `/social-media-posts/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SocialPosts", "SocialAnalytics"],
    }),

    getAnalytics: builder.query({
      query: () => "/social-media-posts/analytics",
      transformResponse: (response) => response.data || {},
      providesTags: ["SocialAnalytics"],
    }),

    updateMetrics: builder.mutation({
      query: ({ id, ...metrics }) => ({
        url: `/social-media-posts/${id}/metrics`,
        method: "PATCH",
        body: metrics,
      }),
      invalidatesTags: ["SocialPosts", "SocialAnalytics"],
    }),
  }),
});

export const {
  useGetPostsQuery,
  useGetPostByIdQuery,
  useCreatePostMutation,
  useUpdatePostMutation,
  useDeletePostMutation,
  useGetAnalyticsQuery,
  useUpdateMetricsMutation,
} = socialMediaApi;
